module.exports = new __parcel__URL__("pendo.6b2acef4.svg").toString();